export const showAlert = alert => ({
    type: "SHOW_ALERT",
    alert
});

export const hideAlert = () => ({
    type: "HIDE_ALERT"
});

export default (state = false, action = {}) => {
    switch(action.type) {
        case "SHOW_ALERT":
            return state = action.alert;
        case "HIDE_ALERT":
            return state = false;
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/showAlert.js